import type { TypographyVariantsOptions } from '@mui/material/styles';

import type { FontSources } from '../external-theme/appearance/types';

const mutateTypographyWithUpdates = (
  typography: TypographyVariantsOptions,
  { fontFamily }: { fontFamily?: string },
  { fontSources }: { fontSources?: FontSources },
): void => {
  if (fontFamily) {
    // eslint-disable-next-line no-param-reassign
    typography.fontFamily = fontFamily;
  }

  Object.keys(typography).forEach((key) => {
    const value =
      typography[key as keyof TypographyVariantsOptions];
    if (
      fontFamily &&
      typeof value === 'object' &&
      'fontFamily' in value
    ) {
      value.fontFamily = fontFamily;
    }
    if (
      fontSources &&
      typeof value === 'object' &&
      'fontSources' in value
    ) {
      value.fontSources = fontSources;
    }
  });
};

export default mutateTypographyWithUpdates;
